import { Crown } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { SocialProofTicker } from "./SocialProofTicker";

const CALENDLY = "https://calendly.com/erodwentpro/rideshare-booking";

export const FinalCTA = () => {
  const r = useReveal();
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-28 sm:py-36 px-5 sm:px-8 overflow-hidden"
    >
      {/* Gold radial glow backdrop */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(61,26,104,0.55) 0%, rgba(5,3,10,0) 60%)",
        }}
      />
      <div className="gold-divider absolute top-0 inset-x-0" />

      <div ref={r} className="reveal relative max-w-3xl mx-auto text-center">
        <Crown
          className="w-8 h-8 text-[#D4AF37] mx-auto mb-6 crown-shimmer"
          strokeWidth={1.4}
        />
        <span className="font-sans text-xs uppercase tracking-[0.32em] text-[#D4AF37]">
          Reserve Your Throne
        </span>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mt-6 leading-[1.05] tracking-tight">
          Ready for a peaceful,{" "}
          <span className="italic gold-text">private ride?</span>
        </h2>
        <p className="font-sans text-base sm:text-lg text-[#A89FBB] font-light mt-6 leading-relaxed">
          Tap below to secure your booking. Discreet, women-first, and
          always royal.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href={CALENDLY}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-book-now-button"
            className="group inline-flex items-center justify-center gap-3 bg-[#D4AF37] text-[#05030A] font-sans font-medium px-10 py-4 text-base uppercase tracking-[0.2em] border border-[#D4AF37] hover:bg-[#F3E5AB] hover:shadow-[0_0_40px_rgba(212,175,55,0.5)] transition-all duration-300"
          >
            Book Your Ride
            <Crown
              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-[8deg]"
              strokeWidth={1.6}
            />
          </a>
        </div>

        <SocialProofTicker />

        <p className="font-serif italic text-sm text-[#A89FBB] mt-8">
          Ride in peace. Arrive in power.
        </p>
      </div>
      <div className="gold-divider absolute bottom-0 inset-x-0" />
    </section>
  );
};
